export default function verifyImei(s) {
  const value = s.replace(/\D/g, ''); // Remove todos caracteres que não são números
  const etal = /^[0-9]{15}$/;
  if (!etal.test(value)) { return false; }
  let sum = 0;
  let mul = 2;
  const l = 14;
  for (let i = 0; i < l; i += 1) {
    const digit = value.substring(l - i - 1, l - i);
    const tp = parseInt(digit, 10) * mul;
    if (tp >= 10) { sum += (tp % 10) + 1; } else { sum += tp; }
    if (mul === 1) { mul += 1; } else { mul -= 1; }
  }
  const chk = ((10 - (sum % 10)) % 10);
  if (chk !== parseInt(value.substring(14, 15), 10)) { return false; }
  return true;
}
